module.exports = __webpack_public_path__ + "static/media/first_degree_icon.b6ff5733.svg";